"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const trim_char_1 = require("../maps/trim_char");
exports.regexTrim = trim_char_1.default("/");
exports.default = exports.regexTrim;
//# sourceMappingURL=regex_trim.js.map